import { defineMessages } from 'react-intl';

export default defineMessages({
  address: {
    id: 'landingMozza.hero.searchBar.addressInput.address',
    defaultMessage: 'Adresse ou ville',
  },
});
